import { configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/auth';
import authGuestReducer from './slices/authGuest';
import cartReducer from './slices/cart';
import cartGuestReducer from './slices/cartGuest';
import genealogyReducer from './slices/genealogy';
import notificationReducer from './slices/notification';
import announcementReducer from './slices/announcement';
import subscriptionReducer from './slices/subscription';
import messageReducer from './slices/message';
import errorsReducer from './slices/error';

const reducer = {
    auth: authReducer,
    authGuest: authGuestReducer,
    cart: cartReducer,
    cartGuest: cartGuestReducer,
    genealogy: genealogyReducer,
    notification: notificationReducer,
    announcement: announcementReducer,
    subscription: subscriptionReducer,
    message: messageReducer,
    error: errorsReducer
}

const store = configureStore({
    reducer: reducer,
    devTools: true
})

export default store;